export const est = {
  Hello: "Tere",
  "Ready to travel": "Valmis reisimiseks",
  Dashboard: "Juhtpaneel",
  Favourites: "Lemmikud",
  "Explore routes": "Uurige marsruute",
  Search: "Otsi",
  "Add to favourite": "Lisa lemmikutesse",
  Favourite: "Lemmik",
  "See Rides": "Vaata sõite",
  "Favourite routes": "Lemmikmarsruudid",
  "My Schedule": "Minu ajakava",
  "Market Place": "Turuplats",
  "Feedback/Report": "Tagasiside/Raport",
  "Log out": "Logi välja",
  NOTIFICATION: "TEAVITUS",
  "requested to join the ride.": "soovib sõiduga liituda.",
  "accepted your request to join the ride.":
    "aktsepteeris teie taotlust sõiduga liituda.",
  "rejected your request to join the ride.":
    "lükkas tagasi teie taotluse sõiduga liituda.",
  Cars: "Autod",
  Passenger: "Reisija",
  Filters: "Filtrid",
  "Show Rides after": "Näita sõite pärast",
  ALL: "KÕIK",
  MINE: "MINU",
  "secs ago": "sekundit tagasi",
  "mins ago": "minutit tagasi",
  "hrs ago": "tundi tagasi",
  "days ago": "päeva tagasi",
  "months ago": "kuud tagasi",
  Seats: "Kohad",
  "Request for seat": "Taotlus koha kohta",
  "Request ride": "Sõidu taotlus",
  "ADDITIONAL INFORMATION": "LISAINFORMATSIOON",
  "CONTACT DETAILS": "KONTAKTANDMED",
  Cancel: "Loobu",
  Request: "Taotlus",
  "Load more": "Laadi rohkem",
  "Request sent successfully.": "Taotlus saadetud edukalt.",
  Close: "Sulge",
  "Passengers count": "Reisijate arv",
  "Ask to join": "Küsi liitumist",
  "Travelling with pets": "Reisimine lemmikloomadega",
  "Show Passengers after": "Näita reisijaid pärast",
  "New Ride": "Uus sõit",
  TIME: "AEG",
  "Depart time": "Väljumise aeg",
  "Arriving time": "Saabumise aeg",
  EXPENSES: "KULUD",
  Cost: "Hind",
  ROUTE: "MARSRUUT",
  "Departing point": "Väljumispunkt",
  "Arriving point": "Saabumispunkt",
  "DESCRIBE THE ROUTE": "KIRJELDAGE MARSUUTI",
  Stoppage: "Peatus",
  "CAR DETAILS": "AUTO ÜKSUSED",
  "Seats offering": "Pakkumiste kohad",
  "PRIVACY SETTINGS": "PRIVAATSUSSEADED",
  "Are pets allowed in your car": "Kas lemmikloomad on teie autos lubatud",
  "Are you accepting parcels": "Kas võtate vastu pakke",
  "I am travelling with electric car": "Ma reisin elektriautoga",
  "Show contact details": "Näita kontaktandmeid",
  Post: "Postita",
  "New Passenger Ticket": "Uus reisipilet",
  "Number of Passengers": "Reisijate arv",
  Details: "Detailid",
  "Are you travelling with pets?": "Kas reisite lemmikloomadega?",
  "Show contact details?": "Näidata kontaktandmeid?",
  Visit: "Külasta",
  Requests: "Päringud",
  cost: "hind",
  "Electric Car": "Elektriauto",
  "Accepting Parcels": "Pakkide vastuvõtmine",
  "Pets allowed": "Lemmikloomad lubatud",
  "Seats left": "Jäänud kohad",
  "Alerts and News": "Hoiatused ja uudised",
  "Favourites Routes": "Lemmikuteed",
  "Traffic Alerts and General News": "Liikluse hoiatused ja üldised uudised",
  "Feedback or Report an issue": "Tagasiside või probleemi raporteerimine",
  "Buy and Sell Bus/Train tickets": "Bussi- ja rongipiletite ostmine ja müük",
  "On sale": "Müügil",
  Offers: "Pakkumised",
  LIVE: "LIVE",
  CANCELLED: "TÜHISTATUD",
  RESERVED: "BRONEERITUD",
  "": "",
  "Offered Price": "Pakutud hind",
  Price: "Hind",
  passengers: "reisijad",
  Updated: "Uuendatud",
  "Request to join": "Taotlus liitumiseks",
  Accepted: "Vastu võetud",
  "Set Offer": "Määra pakkumine",
  "Add Route": "Lisa marsruut",
  Accept: "Võta vastu",
  "Let's travel": "Räägime reisimisest",
  "Register me :)": "Registreeri mind :)",
  Apply: "Rakenda",
  Clear: "Tühjenda",
  Reject: "Lükka tagasi",
  Delete: "Kustuta",
  pending: "ootab",
  rejected: "tagasi lükatud",
  accepted: "vastu võetud",
  Yes: "Jah",
  No: "Ei",
  "NOT FOUND": "EI LEITUD",
  "Go back": "Tagasi",
  "Are pets allowed in your car?": "Kas lemmikloomad on teie autos lubatud?",
  "Are you accepting parcels?": "Kas võtate vastu pakke?",
  Feedback: "Tagasiside",
  feedback: "tagasiside",
  Report: "Aruanne",
  "Report an issue": "Raporteeri probleemist",
  Email: "E-post",
  Password: "Parool",
  "Display name*": "Näidatav nimi*",
  "Email*": "Email*",
  "Password*": "Parool*",
  "Email address": "Emaili aadress",
  "Tell us your email address": "Räägi meile oma emaili aadressist",
  "Choose a password": "Vali parool",
  "Jason Valiin": "Jason Valiin",
  "Ariving City*": "Saabumislinn*",
  "Offer price": "Pakkumise hind",
  "Additional Information": "Lisainformatsioon",
  Messenger: "Sõnumirakendus",
  Text: "Tekst",
  WhatsApp: "WhatsApp",
  "Depart city*": "Väljumislinn*",
  "Country*": "Riik*",
  "Departure Point": "Väljumispunkt",
  Comment: "Kommentaar",
  "Ticket price*": "Pileti hind*",
  "Messanger Username": "Sõnumirakenduse kasutajanimi",
  "WhatsApp Number": "WhatsAppi number",
  "Text Message": "Tekstsõnum",
  "Offered price*": "Pakutud hind*",
  "Number of Passengers*": "Reisijate arv*",
  "Cost*": "Kulu*",
  "Seats offering (minimum 1)": "Pakutavad istekohad (vähemalt 1)",
  Tartu: "Tartu",
  $: "$",
  "additional information": "lisainformatsioon",
  john_simon: "john_simon",
  "+372 0330-0002": "+372 0330-0002",
  Tallinn: "Tallinn",
  Estonia: "Eesti",
  "Ride description": "Sõidu kirjeldus",
  Messanger: "Sõnumirakendus",
  "Phone Number": "Telefoninumber",
  john01: "john01",
  "+372 3994 ....": "+372 3994 ....",
  "The ticket is from Tart": "Pilet on Tartust",
  $15: "$15",
  "I would like to travel back too...": "Ma sooviksin samuti tagasi reisida...",
  "Passenger seats": "Reisijate istekohad",
  report: "aruande koostamine",
  "New depart time": "Uus väljumisaeg",
  "Depart time*": "Väljumisaeg*",
  "Arriving time*": "Saabumisaeg*",
  Country: "Riik",
  "Arriving point*": "Saabumiskoht*",
  "Departing from": "Väljumiskoht",
  "Arriving at": "Saabumiskoht",
  "Departing point*": "Väljumiskoht*",
  "Choose a country and cities": "Vali riik ja linnad",
  "Request sent successfully": "Päring saadeti edukalt",
  "Hello, I would like to join.": "Tere, ma soovin liituda.",
  "Create new route": "Loo uus marsruut",
  BUY: "OSTA",
  "Offer has been made successfully": "Pakkumine on edukalt tehtud",
  Confirm: "Kinnita",
  Update: "Uuenda",
  Cancle: "Tühista",
  Submit: "Esita",
  "No data": "Andmed puuduvad",
  "Delay ride": "Viivita sõitu",
  "Cancel ride": "Tühista sõit",
  "Report ride": "Teata sõidust",
  ACCEPTED: "VASTUVÕETUD",
  Buy: "Osta",
  "Delete ad.": "Kustuta kuulutus",
  "ON SALE": "MÜÜGIS",
  SOLD: "MÜÜDUD",
  "SALE CANCELLED": "MÜÜK TÜHISTATUD",
  "Delay trip": "Viivita reisi",
  "Cancel trip": "Tühista reis",
  "Report trip": "Teata reisist",
  TO: "KUJUDEST",
  "New Sale": "Uus müük",
  "TIME*": "AEG*",
  "TYPE OF TICKET*": "PILETI TÜÜP*",
  BUS: "Buss",
  TRAIN: "Rong",
  "EXPENSES*": "KULUD*",
  "Something went wrong, please try again later.":
    "Midagi läks valesti, palun proovi hiljem uuesti.",
  "Request new ride": "Tellimus uuele sõidule",
  "LOCATION*": "ASUKOHT*",
  "Remove Stoppage": "Eemalda peatus",
  "CAR DETAILS*": "AUTO ANDMED*",
  "Start Point": "Alguspunkt",
  Submitted: "Esitatud",
  NOTIFICATIONS: "TEAVITUSED",
  "Password reset": "Parooli lähtestamine",
  "Reset password": "Lähtesta parool",
  "An email with link to reset your password will be sent to you.":
    "E-kiri, milles on link parooli lähtestamiseks, saadetakse teile.",
  Signup: "Registreeri",
  "I want to register a new account": "Soovin registreerida uue konto",
  "Welcome Traveller": "Tere tulemast reisijat!",
  "All the fields with * are required!":
    "Kõik väljad märgistatud * on kohustuslikud!",
  "I already have an account": "Mul on juba konto olemas",
  "ON GOING": "JÄTKUV",
  "minute ago": "minut tagasi",
  "minutes ago": "minutit tagasi",
  "hours ago": "tundi tagasi",
  "Expore routes": "Avasta marsruudid",
};
